function getTableColumns(data) {
  console.log(data, 'datadata')
  const columns = [].concat(data.comboDetails)
  const arr = [
    {
      name: `V${data.memberLevel}优惠`,
      value: '-￥' + data.memberDiscountAmount,
      display: data.memberDiscountAmount,
    },
    // {
    //   name: '运费',
    //   value: '￥' + data.freightAmount,
    //   display: data.freightAmount
    // },
    // {
    //   name: '运费',
    //   value: '包邮',
    //   display: !data.freightAmount
    // },
    {
      name: '优惠券',
      //   name: `优惠券${data.couponName}`,
      value: '-￥' + data.couponAmount,
      display: data.couponAmount,
    },
    {
      name: '余额券',
      value: '-￥' + data.balanceAmount,
      display: data.balanceAmount,
    },
    {
      name: '实付金额',
      value: '￥' + data.payAmount,
      display: data.payAmount,
    },
  ].filter((e) => e.display)
  arr.forEach((e) => {
    columns.push(e)
  })
  return columns
}
export default function () {
  const { data, type } = arguments[0]
  return {
    class: 'order-table',
    form: [
      {
        type: 'table',
        wrapperCol: 24,
        dataSource: getTableColumns(data),
        showPagination: false,
        columns: [
          {
            title: '酒店/景点名称',
            dataIndex: 'businessName',
            type: 'ct-200',
            display: true,
          },
          {
            title: '商品名称',
            dataIndex: 'productName',
            type: 'ct-100',
            display: true,
          },
          {
            title: '单价（元）',
            dataIndex: 'salePrice',
            type: 'ct-100',
            display: data.fromType === '14',
          },
          {
            title: '数量',
            dataIndex: 'productQuantity',
            type: 'ct-100',
            display: true,
            customRender: (text, records) => {
              if (records.productQuantity) {
                if (!records.hotelRoomName) {
                  return records.productQuantity + '张'
                } else {
                  return records.productQuantity + '晚'
                }
              }
            },
          },
          {
            title: '订金(元)',
            dataIndex: 'totalAmount',
            type: 'ct-100',
            display: true,
            // fixed: 'right',
            customRender: (text, records, index, h) => {
              if (index == 0) {
                return {
                  children: data.totalAmount,
                  attrs: {
                    rowSpan: data.comboDetails.length,
                  },
                }
              } else {
                return {
                  attrs: {
                    colSpan: 0,
                  },
                }
              }
            },
          },
          {
            title: '尾款金额(元)',
            display: true,
            dataIndex: 'preSellCjPrice',
            customRender: (text, records, index, h) => {
              if (records.name) {
                return {
                  children: records.name + records.value,
                  attrs: {
                    colSpan: 2,
                    rowSpan: 1,
                  },
                }
              }
              if (index == 0) {
                return {
                  children: data.preSellCjPrice,
                  attrs: {
                    rowSpan: data.comboDetails.length,
                  },
                }
              }
              return {
                attrs: {
                  rowSpan: 0,
                },
              }
            },
          },
        ].filter((e) => e.display),
      },
    ],
  }
}
